.base,
.base *,
.base *::before,
.base *::after {
  box-sizing: border-box;
}

.base {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: var(--space-6) var(--space-4) var(--space-16);
  overflow: hidden;

  background: var(--bg-base);
  color: var(--text-primary);
  font-family: var(--font-sans);
}

/* ── Card ── */

.card {
  position: relative;
  z-index: var(--z-base);
  width: 100%;
  max-width: 420px;
  margin: var(--space-4);
  border-radius: var(--radius-xl);
  isolation: isolate;
}

/* Gradient hairline, masked to the border only. */
.card::before {
  content: '';
  position: absolute;
  inset: 0;
  padding: 1px;
  border-radius: inherit;
  background: linear-gradient(
    135deg,
    var(--accent-primary),
    var(--accent-secondary),
    var(--brand-purple-light)
  );
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  opacity: 0.4;
  transition: opacity var(--duration-slow) var(--ease-default);
}

.card:hover::before {
  opacity: 0.8;
}

.cardInner {
  position: relative;
  padding: var(--space-8);
  border-radius: inherit;
  background: var(--glass-bg);
  backdrop-filter: var(--glass-blur);
  -webkit-backdrop-filter: var(--glass-blur);
  box-shadow: var(--shadow-lg);
}

/* ── Logo ── */

.logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  margin-bottom: var(--space-8);
}

.logoImage {
  height: 40px;
}

.logoText {
  font-family: var(--font-display);
  font-size: var(--text-lg);
  font-weight: var(--weight-bold);
  letter-spacing: var(--tracking-caps);
  text-transform: uppercase;
  color: var(--accent-secondary);
}

/* ── Heading ── */

.title {
  margin: 0 0 var(--space-1);
  font-size: var(--text-xl);
  font-weight: var(--weight-semi);
  text-align: center;
}

.subtitle {
  margin: 0 0 var(--space-6);
  font-size: var(--text-base);
  text-align: center;
  color: var(--text-muted);
}

/* ── Banners ── */

/* Spacing only — Notice owns the rest. */
.banner {
  margin-bottom: var(--space-4);
}

/* ── Footer ── */

.footer {
  position: relative;
  z-index: var(--z-base);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3);
  margin-top: var(--space-10);
  text-align: center;
}

.contact,
.copyright {
  margin: 0;
  font-size: var(--text-xs);
  color: var(--text-muted);
}

.copyright {
  opacity: 0.7;
}

.contactLink {
  color: var(--text-muted);
  text-decoration: none;
  transition: color var(--duration-fast) var(--ease-default);
}

.contactLink:hover {
  color: var(--accent-secondary);
  text-decoration: underline;
}

.legal {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: var(--space-4);
  margin: 0;
}

.legalLink {
  font-size: var(--text-xs);
  color: var(--text-muted);
  text-decoration: none;
  transition: color var(--duration-fast) var(--ease-default);
}

.legalLink:hover {
  color: var(--text-secondary);
  text-decoration: underline;
}

.legalDot {
  width: 3px;
  height: 3px;
  border-radius: var(--radius-round);
  background: var(--border-default);
}

@media (prefers-reduced-motion: reduce) {
  .card::before {
    transition: none;
  }
}
